<template>
  <div class="dashboard-layout h-screen flex">
    <Sidebar :collapsed="sidebarCollapsed" />
    
    <div class="flex-1 flex flex-col overflow-hidden">
      <Header 
        title="Developer Documentation" 
        :showSearch="false" 
        :showMenuToggle="true" 
        @toggle-sidebar="toggleSidebar"
      />
      
      <!-- Main Content -->
      <main class="flex-1 overflow-auto bg-gray-100 dark:bg-gray-800 p-6 transition-all duration-300">
        <div class="container mx-auto py-6 px-4">
          <h1 class="text-3xl font-bold mb-6 dark:text-white">Developer Documentation</h1>
          
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div class="lg:col-span-2">
              <DevDocs />
            </div>
            
            <div class="bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
              <h2 class="text-xl font-semibold mb-3 dark:text-white">Quick Links</h2>
              <ul class="space-y-2">
                <li v-for="link in quickLinks" :key="link.name">
                  <a 
                    :href="link.url" 
                    target="_blank" 
                    class="text-blue-600 dark:text-blue-400 hover:underline flex items-center"
                  >
                    <span class="mr-1">{{ link.name }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </li>
              </ul>
              
              <div class="mt-6">
                <h3 class="font-medium mb-2 dark:text-white">Backend Technologies</h3>
                <div class="flex flex-wrap gap-2">
                  <span v-for="tech in backendTechs" :key="tech" class="px-2 py-1 bg-gray-200 dark:bg-gray-700 rounded text-sm dark:text-gray-300">
                    {{ tech }}
                  </span>
                </div>
              </div>

              <div class="mt-4">
                <h3 class="font-medium mb-2 dark:text-white">Frontend Technologies</h3>
                <div class="flex flex-wrap gap-2">
                  <span v-for="tech in frontendTechs" :key="tech" class="px-2 py-1 bg-gray-200 dark:bg-gray-700 rounded text-sm dark:text-gray-300">
                    {{ tech }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import DevDocs from '../components/DevDocs.vue';
import Header from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import apiService from '../utils/api';

const sidebarCollapsed = ref(false);
const quickLinks = ref([
  { name: 'API Documentation', url: apiService.getSwaggerUrl() },
  { name: 'Flask Documentation', url: 'https://flask.palletsprojects.com/en/2.0.x/' },
  { name: 'Vue.js Documentation', url: 'https://vuejs.org/guide/introduction.html' },
  { name: 'OpenLayers Documentation', url: 'https://openlayers.org/en/latest/doc/' },
  { name: 'Tailwind CSS', url: 'https://tailwindcss.com/docs' }
]);

const backendTechs = ref([
  'Flask', 'SQLAlchemy', 'PostgreSQL', 'Flasgger', 'JWT', 'Flask-CORS'
]);

const frontendTechs = ref([
  'Vue 3', 'Tailwind CSS', 'Pinia', 'Vue Router', 'OpenLayers', 'Chart.js', 'Axios'
]);

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};
</script>

<style scoped>
/* Add component-specific styles here */
</style>